import oldEnterpriseManage from './oldEnterpriseManage'
import oldOrderManage from './oldOrderManage'
import oldUserManage from './oldUserManage'

import oldPointManage from './oldPointManage'
export default [{
  path: '/null',
  component: () =>
    import('@/components'),
  children: [
    ...oldPointManage,
    ...oldEnterpriseManage,
    ...oldOrderManage,
    ...oldUserManage
  ]
}]



// WEBPACK FOOTER //
// ./src/router/oldPlatform/index.js